import React from 'react';
import { Card } from "react-bootstrap";
import face_tamas_tettamanti from "../../assets/img/face_tamas_tettamanti.jpg";
import ShowMoreText from "react-show-more-text";
import projTettamantiT_microscopic from "../../assets/img/projTettamantiT_microscopic.png";

const T_Tettamanti_microscopic = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={projTettamantiT_microscopic} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_tamas_tettamanti}
              /* this will be the text on the banner */
              alt="Microscopic traffic simulation with Artificial Intelligence"
            />{" "}
            <p className="text7">Tamás Tettamanti</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The task is to develop an AI application which is able to mimic a road traffic dynamics. As an
            initial step the traffic scenario must be created in <a href="https://sumo.dlr.de">SUMO</a> traffic simulator, i.e., the traffic
            network dynamics realized in SUMO must be taught to AI. Scalability of the method should
            be investigated. The main output of the research is to find a usable method (including the
            proper AI algorithm and feature selection) for urban traffic model or freeway traffic model.           
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default T_Tettamanti_microscopic;